import React from 'react';
import { Button } from '@mui/material';
import GlobalStyles from '../../styles/GlobalStyles';

const PrimaryButton = (props) => {
  return <Button style={GlobalStyles.primaryBtn} {...props}></Button>;
};

export default PrimaryButton;
